<script setup lang="ts">
  import { provide, useTemplateRef } from 'vue'
  import ModalChangeEmail, {
    type ShowChangeEmailParams
  } from '../modals/TenantUserModalChangeEmail.vue'
  import ModalChangeName, {
    type ShowChangeNameModalParams
  } from '../modals/TenantUserModalChangeName.vue'
  import ModalChangeJobTitle, {
    type ShowChangeJobTitleModalParams
  } from '../modals/TenantUserModalChangeJobTitle.vue'
  import ModalChangePhoneNumber, {
    type ShowChangePhoneNumberModalParams
  } from '../modals/TenantUserModalChangePhoneNumber.vue'
  import ModalScheduleActivation, {
    type ShowScheduleActivationModalParams
  } from '../modals/TenantUserModalScheduleActivation.vue'
  import ModalScheduleDeactivation, {
    type ShowScheduleDeactivationModalParams
  } from '../modals/TenantUserModalScheduleDeactivation.vue'
  import ModalActivate, {
    type ShowActivateModalParams
  } from '../modals/TenantUserModalActivate.vue'
  import ModalDeactivate, {
    type ShowDeactivateModalParams
  } from '../modals/TenantUserModalDeactivate.vue'
  import ModalGrantTenantAdmin, {
    type ShowGrantTenantAdminModalParams
  } from '../modals/TenantUserModalGrantTenantAdmin.vue'
  import ModalRevokeTenantAdmin, {
    type ShowRevokeTenantAdminModalParams
  } from '../modals/TenantUserModalRevokeTenantAdmin.vue'
  import { tenantUserModalsKey } from './tenant-user-modals'

  const modalChangeEmailRef = useTemplateRef('modalChangeEmailRef')
  const modalChangeNameRef = useTemplateRef('modalChangeNameRef')
  const modalChangeJobTitleRef = useTemplateRef('modalChangeJobTitleRef')
  const modalChangePhoneNumberRef = useTemplateRef('modalChangePhoneNumberRef')
  const modalScheduleActivationRef = useTemplateRef(
    'modalScheduleActivationRef'
  )
  const modalScheduleDeactivationRef = useTemplateRef(
    'modalScheduleDeactivationRef'
  )
  const modalActivateRef = useTemplateRef('modalActivateRef')
  const modalDeactivateRef = useTemplateRef('modalDeactivateRef')
  const modalGrantTenantAdminRef = useTemplateRef('modalGrantTenantAdminRef')
  const modalRevokeTenantAdminRef = useTemplateRef('modalRevokeTenantAdminRef')

  const modals = {
    showChangeEmail: (params: ShowChangeEmailParams) => {
      modalChangeEmailRef.value?.showModal(params)
    },
    showChangeName: (params: ShowChangeNameModalParams) => {
      modalChangeNameRef.value?.showModal(params)
    },
    showChangeJobTitle: (params: ShowChangeJobTitleModalParams) => {
      modalChangeJobTitleRef.value?.showModal(params)
    },
    showChangePhoneNumber: (params: ShowChangePhoneNumberModalParams) => {
      modalChangePhoneNumberRef.value?.showModal(params)
    },
    showScheduleActivation: (params: ShowScheduleActivationModalParams) => {
      modalScheduleActivationRef.value?.showModal(params)
    },
    showScheduleDeactivation: (params: ShowScheduleDeactivationModalParams) => {
      modalScheduleDeactivationRef.value?.showModal(params)
    },
    showActivate: (params: ShowActivateModalParams) => {
      modalActivateRef.value?.showModal(params)
    },
    showDeactivate: (params: ShowDeactivateModalParams) => {
      modalDeactivateRef.value?.showModal(params)
    },
    showGrantTenantAdmin: (params: ShowGrantTenantAdminModalParams) => {
      modalGrantTenantAdminRef.value?.showModal(params)
    },
    showRevokeTenantAdmin: (params: ShowRevokeTenantAdminModalParams) => {
      modalRevokeTenantAdminRef.value?.showModal(params)
    }
  }

  provide(tenantUserModalsKey, modals)

  defineExpose(modals)
</script>
<template>
  <slot />
  <ModalChangeEmail ref="modalChangeEmailRef" />
  <ModalChangeName ref="modalChangeNameRef" />
  <ModalChangeJobTitle ref="modalChangeJobTitleRef" />
  <ModalChangePhoneNumber ref="modalChangePhoneNumberRef" />
  <ModalScheduleActivation ref="modalScheduleActivationRef" />
  <ModalScheduleDeactivation ref="modalScheduleDeactivationRef" />
  <ModalActivate ref="modalActivateRef" />
  <ModalDeactivate ref="modalDeactivateRef" />
  <ModalGrantTenantAdmin ref="modalGrantTenantAdminRef" />
  <ModalRevokeTenantAdmin ref="modalRevokeTenantAdminRef" />
</template>
